import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { isEqual, keyBy, merge } from "lodash";

import Graph_QL, { DynamicDataObk } from "../..";
import { SectionsInfo } from "../GQLCalls/getLfStructureCall";


export type LfSectionItem = DynamicDataObk<SectionsInfo[]>
type DeleteSectionItem = DynamicDataObk<number[]>

const lfSectionsDataAdapter = createEntityAdapter({
  selectId: (item: LfSectionItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<LfSectionItem, string>, {con, data}: LfSectionItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "section_id")
    data.forEach((entry) => dataDictionary[entry.section_id] = entry)
    const newPayload = {con, data: Object.values(dataDictionary)}
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) ) {
      lfSectionsDataAdapter.upsertOne(state, newPayload);
    }
  } else { lfSectionsDataAdapter.addOne(state, {con, data})}
}

const upsertPayloadAndState = (state: EntityState<LfSectionItem, string>, {con, data}: LfSectionItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "section_id")
    data.forEach((entry) => dataDictionary[entry.section_id] = merge({}, dataDictionary[entry.section_id], entry));
    const newPayload = {con, data: Object.values(dataDictionary)}
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) ) {
      lfSectionsDataAdapter.upsertOne(state, newPayload);
    }
  } else { lfSectionsDataAdapter.addOne(state, {con, data})}
}


const removeDeletedFromState = (state: EntityState<LfSectionItem, string>, {con, data}: DeleteSectionItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {;
    const newPayload = {con, data: state.entities[identifier].data.filter((section) =>  section.section_id? !data.includes(section.section_id) : false)}
    lfSectionsDataAdapter.upsertOne(state, newPayload);
  }
}

const lfSectionsSlice = createSlice({
  name: "lfSections",
    initialState: lfSectionsDataAdapter.getInitialState<LfSectionItem[]>([]),
      reducers: {
        maintained: (state, {payload}:PayloadAction<LfSectionItem>) => {
          mergePayloadAndState(state, payload);
        },
        upsert: (state, {payload}:PayloadAction<LfSectionItem>) => {
          upsertPayloadAndState(state, payload);
        },
        remove: (state, {payload}: PayloadAction<DeleteSectionItem>) => {
          removeDeletedFromState(state, payload)
        }
    }
})

export const LfSectionActions = lfSectionsSlice.actions;
export default lfSectionsSlice.reducer;